<template>
  <canvas donut/>
</template>

<script>
import { animate, getOffsetTop } from '@/utils';

export default {
  name: 'Donut',
  data() {
    return {
      ctx: null,
      ew: 0,
      eh: 0,
      val1: 1,
      val2: 1,
      animated: false,
    };
  },
  props: {
    info: { type:Object }
  },
  watch: {
    sv: 'checkDraw',
  },
  methods: {
    checkDraw() {
      if (this.animated) return;
      const sv = this.sv;
      const d = getOffsetTop(this.$el) - sv;
      const h = window.innerHeight;
      if (d < h * 0.8) {
        animate(0,1,60, this.draw);
        this.animated = true;
      }
    },
    resize() {
      this.init();
      this.draw(1);
    },
    init() {
      this.ew = this.$el.offsetWidth * 2;
      this.$el.width = this.ew;
      this.$el.height = this.ew;
    },
    draw(r) {
      const ew = this.ew;
      const ctx = this.ctx;
      const c = ew * 0.5;

      ctx.clearRect(0,0, ew, ew);

      ctx.fillStyle = '#DDE1E7';
      ctx.beginPath();
      ctx.moveTo(c,c);
      ctx.arc(c,c,c, - Math.PI * 0.5,Math.PI * 2 * r - Math.PI * 0.5);
      ctx.fill();

      ctx.fillStyle = '#C1C7CE';
      ctx.beginPath();
      ctx.moveTo(c,c);
      ctx.arc(c,c,c,- Math.PI * 0.5,Math.PI * 2 * this.val1 *r - Math.PI * 0.5);
      ctx.fill();

      ctx.fillStyle = '#A3A9B1';
      ctx.beginPath();
      ctx.moveTo(c,c);
      ctx.arc(c,c,c,- Math.PI * 0.5,Math.PI * 2 * this.val2 *r - Math.PI * 0.5);
      ctx.fill();

      ctx.fillStyle = '#f7f8fb';
      ctx.beginPath();
      ctx.moveTo(c,c);
      ctx.arc(c,c,c * 0.66, 0,Math.PI * 2);
      ctx.fill();
    }
  },
  mounted() {
    if (!this.info) return;
    const info = this.info;
    const total = info.val1_1 + info.val1_2 + info.val1_3;
    this.val1 = (total - info.val1_3) / total;
    this.val2 = (total - info.val1_3 - info.val1_2) / total;

    this.ctx = this.$el.getContext('2d');
    this.init();
    this.checkDraw();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";

</style>
